module.exports = __webpack_public_path__ + "img/logo-besttutor-1.b1d25d67.png";